import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'customDate',
})
export class CustomDatePipe implements PipeTransform {
  transform(value: any): string {
    if (!value) return ''; // return empty string for null or undefined values

    const datePipe: DatePipe = new DatePipe('en-US');

    // Format date to dd.MM.yyyy
    const formattedDate = datePipe.transform(value, 'dd.MM.yyyy');

    // Format time to HH:mm
    const formattedTime = datePipe.transform(value, 'HH:mm');

    return `${formattedDate} | ${formattedTime}`;
  }
}
